import { render, staticRenderFns } from "./revisionComplemento.vue?vue&type=template&id=30e4ec74&scoped=true"
import script from "./revisionComplemento.vue?vue&type=script&lang=js"
export * from "./revisionComplemento.vue?vue&type=script&lang=js"
import style0 from "./revisionComplemento.vue?vue&type=style&index=0&id=30e4ec74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e4ec74",
  null
  
)

export default component.exports